// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Rmgc","comment":"styles_comment__12-BG"};